import { NgModule } from '@angular/core';
import { OverviewPageModule } from '@com-delta-idp/mnx-skymiles-overview-ui';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ContentEffects } from './data-access/+state/effects/content.effects';
import { DocsEffects } from './data-access/+state/effects/docs.effects';
import { EarnsSummaryEffects } from './data-access/+state/effects/earns-summary.effects';
import { FutureActivityEffects } from './data-access/+state/effects/future-activities.effects';
import { MembershipCardEffects } from './data-access/+state/effects/membership-card.effects';
import { PersonalizationEngineEffects } from './data-access/+state/effects/personalization-engine.effects';
import { SnapshotEffects } from './data-access/+state/effects/snapshot.effects';
import { SummaryContentEffects } from './data-access/+state/effects/summary-content.effects';
import { TrackerEffects } from './data-access/+state/effects/tracker.effects';
import * as fromOverview from './data-access/+state/reducers/overview.reducer';

@NgModule({
  imports: [
    OverviewPageModule,
    StoreModule.forFeature(
      fromOverview.OVERVIEW_FEATURE_KEY,
      fromOverview.reducer
    ),
    EffectsModule.forFeature([
      ContentEffects,
      DocsEffects,
      MembershipCardEffects,
      PersonalizationEngineEffects,
      SnapshotEffects,
      TrackerEffects,
      FutureActivityEffects,
      SummaryContentEffects,
      EarnsSummaryEffects
    ])
  ]
})
export class TrackerModule {}
